<template>
  <div>
    <b-button @click="handleShowOrdersBasket()" :style="cmpnStyle">
      <b-icon icon="cart4"></b-icon>
      Warenkorb
      <b-badge variant="light">{{ formData.commProductsCount }}</b-badge>
    </b-button>

    <b-modal ref="orderBasketModalRef" id="order-basket-modal" title="Einkaufskorb">
      <order-basket
        actionsEnabled
        :basket-c-p-details="formData.basketCPDetails"
        @basket-change-amount="handleBasketChangeAmount" />
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="handleHideOrdersBasket()">Weiter Einkaufen</b-button>
        <b-button variant="warning" @click="handleShowDeliveryDetails()">Bestellen</b-button>
      </template>
    </b-modal>

    <b-modal ref="deliveryDetailsModalRef" id="delivery-details" title="Angaben zur Lieferung">
      <delivery-details :age18Reqrd="age18Reqrd" ref="deliveryDetailsRef"></delivery-details>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="handleHideDeliveryDetails()">Weiter Einkaufen</b-button>
        <b-button @click="handleShowOrdersBasket()">Zurück zum Einkaufskorb</b-button>
        <b-button variant="warning" @click="handleShowFinalOrder()">Bestellen</b-button>
      </template>
    </b-modal>

    <b-modal ref="finalOrderModalRef" id="final-order-modal" title="Bestellung">
      <b-overlay :show="loading">
        <order-basket
          :basket-c-p-details="formData.basketCPDetails"  />
        <div v-if="paymInstKey && isPaypalPI" ref="paypal"></div>
        <div v-if="paymInstKey && isStripePI">
          <div>Karetendaten:</div>
          <div id="stripe-card-element"></div>
          <div id="stripe-card-errors" role="alert" style="color: red;"></div>
        </div>
      </b-overlay>
      <template v-slot:modal-footer>
        <b-button :disabled="loading" variant="primary" @click="handleHideFinalOrder()">
          Weiter Einkaufen</b-button>
        <b-button v-if="!paymInstKey" :disabled="loading" variant="warning"
          @click="handleSendOrder()">Bestellen</b-button>
        <b-button v-if="paymInstKey && isStripePI" :disabled="loading" variant="warning"
          @click="handleCreateStripeOrder()">Bestellen</b-button>
      </template>
    </b-modal>

    <b-modal ref="orderSuccessModalRef" id="order-success" title="Bestellung Information!" ok-only>
      <p v-if="orderSuccSent">
        Ihre Bestellung wurde erfolgreich versendet!
      </p>
      <p v-else style="color: red;">
        Es ist ein fehler aufgetretten bei versenden ihrer Bestellung! Bitte versuchen Sie es erneut später!
      </p>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import * as events from '@/events'
import {round} from './mathHelper'

function _getDefaultFormData () {
  return {
    basketCPDetails: [],
    commProductsCount: 0,
    deliveryDetails: {
      name: null,
      street: null,
      zip: null,
      city: null,
      email: null,
      agb: false,
      age18: false,
      notife: ''
    }
  }
}

const PIT_DEFS = { pitStripe: 'pit-stripe', pitPaypal: 'pit-paypal' }

export default {
  name: 'order-basket-btn',
  version: '0.0.3',
  props: {
    instKey: {
      type: String,
      required: true
    },
    paymInstKey: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    age18Reqrd: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrderBasket: () => import('./OrderBasket.vue'),
    DeliveryDetails: () => import('./DeliveryDetails.vue')
  }, // components
  data () {
    return {
      info: '... loading content!',
      loading: false,
      loaded: false,
      basketKey: null,
      orderSuccSent: true,
      piType: null,
      piMerchantId: null,
      // deliveryDetails: {},
      paypalRendered: false,
      cmpnStyle: {
        backgroundColor: this.bgColor
      },
      stripe: {
        inst: null,
        elements: null,
        card: null
      },
      formData: _getDefaultFormData()
    }
  },
  /* ----- vuejs hooks ----- */
  created () {
    events.bus.onGlobal(events.types.orders.GLGE_ADD_2_BASKET, e => this.handleAdd2Basket(e))
  }, // created
  destroyed () {
    events.bus.offGlobal(events.types.orders.GLGE_ADD_2_BASKET, e => this.handleAdd2Basket(e))
  }, // destroyed
  async mounted () {
    // this.loaded = false
    try {
      let _glapiResp
      const _ordersBasket = JSON.parse(sessionStorage.getItem('ordersBasket'))
      if (_ordersBasket) { // TODO: implement if not expired to be used
        try {
          _glapiResp = await axios.get(config.glapiBaseUri + '/orders/' + this.instKey +
            '/basket/' + _ordersBasket['key'])
        } catch (e) {
          console.log('WARN-REMOVE: OrderBasketBtn.mounted: Not able to obtain the basket: ', _ordersBasket)
        }
      }
      if (!_glapiResp){
        _glapiResp = await axios.get(config.glapiBaseUri + '/orders/' +
          this.instKey + '/basket')
      }
      if ('success' === _glapiResp.data.status) {
        let _glapiOrdersBasket = _glapiResp.data.payload
        this.formData.commProductsCount = _glapiOrdersBasket.commProductsCount || 0
        this.basketKey = _glapiOrdersBasket['key']
        sessionStorage.setItem('ordersBasket', JSON.stringify(_glapiOrdersBasket))
      } else {
        throw new Error('Error by server processing!')
      }
      this.loaded = true
    } catch (e) {
      this.loaded = false
    }
    if (this.paymInstKey) {
      try {
        const _glapiPaymResp = await axios.get(config.glapiBaseUri + '/paym/' +
          this.paymInstKey + '/preferedPIDetails')

        if ('success' === _glapiPaymResp.data.status) {
          this.piType = _glapiPaymResp.data.payload.ppiDetails.piType
          this.piMerchantId = _glapiPaymResp.data.payload.ppiDetails.merchantId
          // TODO: check if stripe is prefered pit
          // this.loadStripeSdk()
          if (this.isStripePI) {
            this.loadStripeSdk()
          } else if (this.isPaypalPI) {
            this.loadPaypalSdk()
          }
        } else {
          throw new Error('Payment API call failed! Status: ' + _glapiPaymResp.data)
        }
        // this.loadPaypalSdk()
      } catch (e) {
        console.error('Error accessing payments API! Exception is: ', e)
      }
    }
  }, // mounted
  /* ----- computed properties ----- */
  computed: {
    basketTotal: function () {
      return round(this.formData.basketCPDetails.reduce((sum, item) =>
        sum + (item.cpDetail.fragments.price * item.cpAmount), 0), 2)
    }, // basketTotal
    isPaypalPI () {
      return this.piType === PIT_DEFS.pitPaypal
    }, // isPaypalPI
    isStripePI () {
      return this.piType === PIT_DEFS.pitStripe
    } // isStripePI
  }, // computed
  /* ----- private methods ----- */
  methods: {
    /* ----- utility methods ----- */
    loadStripeSdk () {
      console.log('INFO: loading StripeSdk ...')
      const script = document.createElement('script')
      script.src = config.stripeSdkUrl
      script.addEventListener('load', () => {
        // eslint-disable-next-line
        this.stripe.inst = Stripe(config.stripePlatformPK, {
          apiVersion: '2020-08-27',
          stripeAccount: this.piMerchantId
        })
        this.stripe.elements = this.stripe.inst.elements()
        this.stripe.card = this.stripe.elements.create('card')
        // card.mount('#card-element');
        console.log('INFO: StripeSdk loaded!')
      })
      document.head.appendChild(script)
    }, // loadStripeSdk
    loadPaypalSdk (loadCb) {
      if (typeof window.paypal === 'undefined') {
        const script = document.createElement('script')
        script.src = config.paypalBaseUrl + 'client-id=' +
          config.paypalPartnerClientId + '&merchant-id=' +
          this.piMerchantId +
          '&currency=EUR'
        script.addEventListener('load', () => {
          if (loadCb) {
            loadCb()
          }
        })
        document.head.appendChild(script)
      }
    }, // loadPaypalSdk
    renderPaypal () {
      window.paypal.Buttons({
        createOrder: (data, actions) => {
          return this.handleCreatePaymentOrder(data, actions)
        },
        onApprove: async (data, actions) => {
          this.handleOnApprovePayment(data, actions)
        },
        onError: err => {
          console.log(err)
        }
      }).render(this.$refs.paypal)
    }, // renderPaypal
    loadPaypalSdkAndRender () {
      if (typeof window.paypal === 'undefined') {
        this.loadPaypalSdk(this.renderPaypal)
      } else {
        this.renderPaypal()
      }
    }, // loadPaypalSdkAndRender
    /* ----- handler methods ----- */
    async changeCPAmountInBasket (cpKey, amount) {
      try {
        const _resp = await axios.post(config.glapiBaseUri + '/orders/basket/' +
          this.basketKey + '/commProduct/' + cpKey + '/' + amount)

        if (_resp.data.status === 'success') {
          this.formData.commProductsCount = _resp.data.payload.commProductsCount
        } else {
          throw new Error('Server error!')
        }
      } catch (e) {
        // TODO: consider showing message
        console.error('Error during processing! Exception is: ', e)
      }
    }, // changeCPAmountInBasket
    async handleAdd2Basket (ev) {
      await this.changeCPAmountInBasket(ev.detail.commProduct, ev.detail.amount)
    }, // handleAdd2Basket
    async handleBasketChangeAmount({ key, amount }) {
      await this.changeCPAmountInBasket(key, amount)
      this.handleShowOrdersBasket()
    },
    // TODO: generalize handleAdd2Basket and removeFromBasket
    async removeFromBasket(cpKey) {
      const _ordersBasket = JSON.parse(sessionStorage.getItem('ordersBasket'))
      try {
        if (!_ordersBasket || !_ordersBasket['key']) {
          throw new Error('Order basket not available!')
        }
        const _resp = await axios.post(config.glapiBaseUri + '/orders/basket/' +
          _ordersBasket['key'] + '/commProduct/' + cpKey + '/' + (-1))

        if (_resp.data.status === 'success') {
          // this.formData.commProducts = _resp.data.payload.commProducts
          this.formData.commProductsCount = _resp.data.payload.commProductsCount
        } else {
          throw new Error('Server error!')
        }
      } catch (e) {
        // TODO: consider showing message
        console.error('Error during processing! Exception is: ', e)
      }
      this.handleShowOrdersBasket()
    }, // removeFromBasket
    async handleShowOrdersBasket () {
      this.handleHideOrdersBasket()
      this.handleHideDeliveryDetails()
      try {
        const _resp = await axios.get(config.glapiBaseUri + '/orders/' +
          this.instKey + '/basket/' + this.basketKey + '/details')

        this.formData.basketCPDetails = _resp.data.payload.basketDetails
      } catch (e) {
        console.error('Error processing the basket details! Exception is: ', e);
      }
      // TODO: since it is getting called from other functions consider checking if it is already showing?
      this.$refs.orderBasketModalRef.show()
    }, // handleShowOrdersBasket
    handleHideOrdersBasket () {
      this.$refs.orderBasketModalRef.hide()
    }, // handleHideOrdersBasket
    handleShowDeliveryDetails () {
      this.handleHideOrdersBasket()
      this.$refs.deliveryDetailsModalRef.show()
    }, // handleShowDeliveryDetails
    handleHideDeliveryDetails () {
      this.$refs.deliveryDetailsModalRef.hide()
    }, // handleHideDeliveryDetails
    async handleShowFinalOrder () {
      const _ddRef = this.$refs.deliveryDetailsRef
      if (_ddRef.validFormData) { // TODO: only in case payments are available
        this.formData.deliveryDetails = _ddRef.formData.deliveryDetails
        // this.handleShowFinalOrder()
        this.handleHideDeliveryDetails()
        this.$refs.finalOrderModalRef.show()

        if (this.paymInstKey && this.isStripePI) {
          this.$nextTick(() => {
            this.stripe.card.mount('#stripe-card-element')
            this.stripe.card.on('change', ({ error }) => {
              let displayError = document.getElementById('stripe-card-errors')
              if (error) {
                displayError.textContent = error.message
              } else {
                displayError.textContent = ''
              }
            })
          })
        } else if (this.paymInstKey && this.isPaypalPI) {
          this.$nextTick(() => {
            this.loadPaypalSdkAndRender()
          })
        }
      } else {
        // TODO: toster should be shown
      }
    }, // handleShowFinalOrder
    handleHideFinalOrder () {
      this.$refs.finalOrderModalRef.hide()
    }, // handleHideFinalOrder
    async handleSendOrder () {
      try {
        const _resp = await axios.post(config.glapiBaseUri + '/orders/' +
          this.instKey + '/basket/' + this.basketKey, { basketTotal: this.basketTotal,
          deliveryDetails: this.formData.deliveryDetails })

        // TODO: initialize the new basket
        if (_resp.data.status === 'success') {
          this.formData = _getDefaultFormData()
          this.basketKey = _resp.data.payload.key
          sessionStorage.setItem('ordersBasket', JSON.stringify(_resp.data.payload))
          // this.$refs.orderSuccessModalRef.show()
          this.orderSuccSent = true
        } else {
          throw new Error('Error during processing the order request!')
        }
      } catch (e) {
        console.error('Error processing the basket details! Exception is: ', e)
        this.orderSuccSent = false
      } finally {
        this.$refs.finalOrderModalRef.hide()
        this.$refs.orderSuccessModalRef.show()
      }
    }, // handleSendOrder
    async handleCreateStripeOrder () {
      try {
        this.loading = true
        console.log('INFO: OrderBasketBtn: PO creation started!')
        const _resp = await axios.post(config.glapiBaseUri + '/paym/' +
          this.paymInstKey + '/paymentOrder/pit-stripe',
          { ordersInstKey: this.instKey,
            basketKey: this.basketKey,
            amount: this.basketTotal,
            deliveryDetails: this.formData.deliveryDetails
          })
        console.log('INFO: OrderBasketBtn: PO created!')
        const _result = await this.stripe.inst.confirmCardPayment(
          _resp.data.payload.paymentOrder.pmIntnClientSecret, {
            payment_method: {
              card: this.stripe.card,
              billing_details: {
                name: this.formData.deliveryDetails.name
              }
            }
          })
        if (_result.error) {
          console.log('INFO: PO confirmed error!')
          this.orderSuccSent = false
        } else {
          // The payment has been processed!
          if (_result.paymentIntent.status === 'succeeded') {
            console.log('INFO: OrderBasketBtn: PO confirmed success!')
            const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))
            let iter = 0
            let finalized = false
            while (!finalized && iter++ < 3) {
              try {
                await sleep(3000)
                const _resp2 = await axios.put(config.glapiBaseUri + '/paym/' +
                  this.paymInstKey + '/paymentOrder/pit-stripe',
                  { ordersInstKey: this.instKey,
                    orderId: _resp.data.payload.paymentOrder.ppOrderId
                  }
                )
                console.log('INFO: OrderBasketBtn: PO finalized!')
                this.formData = _getDefaultFormData()
                this.basketKey = _resp2.data.payload.purchaseOrder.newBasketKey
                // TODO: to be implemented correct session handling
                sessionStorage.setItem('ordersBasket', JSON.stringify({ key: _resp2.data.payload.purchaseOrder.newBasketKey }))
                finalized = true
              } catch (e2) {
                console.log('ERROR: OrderBasketBtn: Order still not finalized! Exception is: ', e2)
              }
            }
            this.orderSuccSent = finalized
          }
        }
      } catch (e) {
        console.log('ERROR: OrderBasketBtn: exception is: ', e)
        this.orderSuccSent = false
        this.$refs.orderSuccessModalRef.show()
      } finally {
        this.loading = false
        this.$refs.finalOrderModalRef.hide()
        this.$refs.orderSuccessModalRef.show()
      }
    }, // handleCreateStripeOrder
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async handleCreatePaymentOrder (data, actions) {
      try {
        const _resp = await axios.post(config.glapiBaseUri + '/paym/' +
          this.paymInstKey + '/paymentOrder',
          { ordersInstKey: this.instKey,
            basketKey: this.basketKey,
            amount: this.basketTotal,
            deliveryDetails: this.formData.deliveryDetails
          })

        return _resp.data.payload.paymentOrder.ppOrderId
      } catch (e) {
        // this.$bvToast.toast(e.name + ': ' + e.message)

        this.orderSuccSent = false
        this.$refs.orderSuccessModalRef.show()
      }
    }, // handleCreatePaymentOrder
    async handleOnApprovePayment (data, actions) {
      try {
        const _resp = await axios.put(config.glapiBaseUri + '/paym/' +
          this.paymInstKey + '/paymentOrder',
          { orderId: data.orderID,
            ordersInstKey: this.instKey,
            basketKey: this.basketKey,
            amount: this.basketTotal,
            deliveryDetails: this.formData.deliveryDetails
          })

        this.formData = _getDefaultFormData()
        this.basketKey = _resp.data.payload.purchaseOrder.newBasketKey
        // TODO: to be implemented correct session handling
        sessionStorage.setItem('ordersBasket', JSON.stringify({ key: _resp.data.payload.purchaseOrder.newBasketKey }))
        this.orderSuccSent = true
      } catch (e) {
        // this.$bvToast.toast(e.name + ': ' + e.message)
        console.log('TRACE-REMOVE: OrderBasketBtn.handleOnApprovePayment: exception is: ', e)
        this.orderSuccSent = false
      } finally {
        this.$refs.finalOrderModalRef.hide()
        this.$refs.orderSuccessModalRef.show()
      }
    } // handleOnApprovePayment
  } // methods
}
</script>

<style scoped>
@import '~bootstrap/dist/css/bootstrap.css';
/** TODO: check if necessary to reference all the *css files */
/* @import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~bootstrap-vue/dist/bootstrap-vue-icons.css'; */
</style>
